import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as LeftIcon} from '../../../assets/svg/arrow-left.svg';
import {ReactComponent as RightIcon} from '../../../assets/svg/arrow-right.svg';

import {I18N_NS} from '../../../core/constants/names';
import {Icon} from '../Icon';

import {Buttons, ItemButton} from './styled';

interface PaginationProps {
    currentPageIndex: number;
    disableNext: boolean;
    onPageIndexChange: (index: number) => void;
    disabled?: boolean;
}

export const SimplePagination = ({
    currentPageIndex,
    disableNext,
    onPageIndexChange,
    disabled = false,
}: PaginationProps) => {
    const {t} = useTranslation(I18N_NS);

    return (
        <Buttons>
            <ItemButton
                disabled={disabled || currentPageIndex === 0}
                isSimple
                isActive={false}
                onClick={() => {
                    onPageIndexChange(currentPageIndex - 1);
                }}
            >
                <Icon source={LeftIcon} width={8} height={13} /> {t('components.pagination.back')}
            </ItemButton>
            <ItemButton
                isSimple
                disabled={disabled || disableNext}
                isActive={false}
                onClick={() => {
                    onPageIndexChange(currentPageIndex + 1);
                }}
            >
                {t('components.pagination.Next')} <Icon source={RightIcon} width={8} height={13} />
            </ItemButton>
        </Buttons>
    );
};
